export enum WaiverType {
    exception = "Exception",
    evaluationResult = "EvaluationResult",
    generalWaiver = "GeneralWaiver",
    adjustmentWaiver="AdjustmentWaiver"
  }

  export enum waiverStatusLowerCase {
    approved = "approved",
    approvedConditionally = "approved-conditionally",
    satisfied = "satisfied",
    rejected = "rejected",
    requested = "requested",
    reRequested = "re-requested",
    rescind = "rescind",
    waived = "waived"
  }
  
  export enum waiverApprovalType {
    approve = "Approve",
    approvedConditionally = "Approve-Conditionally",
    reOpen = "Re-Open",
    reject = "Reject",
    waiverRebuttal = "Waiver Rebuttal",
    rescindWaiver = "Rescind Waiver"
  }